// extracted by mini-css-extract-plugin
export default {"container":"SPaymentWIdget_container__kMheu","content":"SPaymentWIdget_content__bwmNa","greetings":"SPaymentWIdget_greetings__WIYq9"};